import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { NumberInputFieldWUT } from '../../../ui/number-input-field';
export const NumberInputWUT = (props)=>{
    const fieldType = FIELD_TYPES.NUMBER_INPUT;
    return /*#__PURE__*/ React.createElement(NumberInputFieldWUT, {
        ...props,
        fieldType: fieldType
    });
};

//# sourceMappingURL=number-input-wut.js.map